export default "__VITE_ASSET__C03o4_y3__"